/* eslint-disable prefer-template */
import { useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Hub } from "aws-amplify";

// material
import { styled } from "@mui/material/styles";
import { Box, Link, Container, Typography } from "@mui/material";
import { Button, Grid, Header, Message } from "semantic-ui-react";
import MyTextInput from "../components/common/form/MyTextInput";
import FORM_TEXT from "../components/common/errors/FormYupFormik";
import { signUpStart } from "../redux/auth/auth.actions";

// Menu
import Menu from "../components/Menu";
import ClientMenuLeft from './common/ClientMenuLeft';
// components
import Page from "../components/Page";
import { MHidden } from "../components/@material-extend";
import DisplayCognitoError from "../components/common/DisplayCognitoError";
// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Register() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currentErrorRegister } = useSelector((state) => state.authReducer);
  const { userId } = useSelector((state) => state.authReducer);
  

  const [passwordShown, setPasswordShown] = useState(false);
  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };
  const initialValues = {
    firstname: "",
    lastname: "",
    username: "",
    password: "",
    phone: "",
    company: "",
  };



  const validationSchema = Yup.object().shape({
    firstname: Yup.string().required("Votre prenom est un champ obligatoire"),
    lastname: Yup.string().required("Votre nom est un champ obligatoire"),
    username: Yup.string()
      .required()
      .email("Adresse e-mail est un champ obligatoire"),
    password: Yup.string().required("Mot de passe est un champ obligatoire"),
    phone: Yup.string()
      .required(FORM_TEXT.REQUIRED_FR)
      .matches(
        /^\+(?:[0-9] ?){6,14}[0-9]$/,
        "Doit être sous la forme + XXXXXXXXX"
      ),
    company: Yup.string().required(FORM_TEXT.REQUIRED_FR),
  });

  const handleSubmit = (values) => {
    try {
      const payload = {
        given_name: values.firstname,
        name: values.firstname + " " + values.lastname,
        family_name: values.lastname,
        username: values.username,
        password: values.password,
        email: values.username,
        phone_number: values.phone,
        website: values.company,
        picture: "",
        profile: "CLIENT",
        gender: "",
      };

      dispatch(signUpStart(payload));

      if(null === userId){

      }
      

      // console.log(userDynamoDB);

      Hub.listen("auth", (data) => {
        const { payload } = data;
        if (payload.event === "signUp") {
          window.localStorage.setItem("usernameConfirm", values.username);
          window.localStorage.setItem("usernameConfirmName", values.firstname + " " + values.lastname);
      
          navigate("/register-confirm", { replace: true });
        }
      });
    } catch (e) {
      console.log(e.message);

    }
  };

  return (
    <RootStyle title="Enregistrer votre compte de plainte | Gestion des plaintes">
      <Menu />

      <ClientMenuLeft />

      <Container>
        <ContentStyle>
          <Box sx={{ mb: 5 }}>
            <Header as="h2" color="blue" textAlign="center">
              Enregistrer votre compte de plainte
            </Header>
          </Box>

          <Grid textAlign="center" verticalAlign="middle">
            <Grid.Column style={{ maxWidth: 450 }}>
              <DisplayCognitoError errorMessage={currentErrorRegister} />
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                <Form className="ui form">
                  <MyTextInput name="firstname" placeholder="Votre prenom" />
                  <MyTextInput name="lastname" placeholder="Votre nom" />
                  <MyTextInput
                    name="phone"
                    placeholder="Votre numéro de téléphone"
                  />
                  <MyTextInput name="company" placeholder="Votre Société" />
                  <MyTextInput name="username" placeholder="Adresse e-mail" />
                  <div className="ui icon input">
                    <MyTextInput
                      name="password"
                      placeholder="Votre mot de passe"
                      type={passwordShown ? "text" : "password"}
                      size="60"
                    />
                    <i
                      aria-hidden="true"
                      onClick={togglePassword}
                      className="eye link icon"
                    ></i>
                  </div>
                  <Button
                    // loading={isSubmitting}

                    type="submit"
                    fluid
                    size="large"
                    color="blue"
                    content="S'inscrire"
                  />
                  {/* <Divider horizontal>Or</Divider>
                <SocialLogin history={history} /> */}
                </Form>
              </Formik>

              <Message>
                <Link
                  underline="none"
                  variant="subtitle2"
                  component={RouterLink}
                  to="/login"
                >
                  S'identifier
                </Link>
              </Message>
            </Grid.Column>
          </Grid>

          <MHidden width="smUp">
            <Typography variant="subtitle2" sx={{ mt: 3, textAlign: "center" }}>
              Already have an account?&nbsp;
              <Link to="/login" component={RouterLink}>
                Login
              </Link>
            </Typography>
          </MHidden>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
